export default (status: string) => {
  if (!status || status.trim().length === 0) {
    return "";
  }
  if (status === "PendingDispatch") {
    return "Dispatched";
  }
  return status.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
};
